var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 367,
    viewBox: "0 0 309 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 351.101V59.2792C0 51.2409 3.3096 43.5579 9.148 38.0421L40.9131 8.01166C46.3522 2.86892 53.557 0 61.0369 0H309V269.474C309 280.914 304.288 291.848 295.983 299.7L236.925 355.533C229.676 362.39 220.084 366.227 210.111 366.263L15.9535 367C7.15158 367.035 0.00887314 359.903 0.00887314 351.092L0 351.101Z",
    fill: "url(#paint0_linear_74_2361)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_2361",
    x1: 154.941,
    y1: 65.7811,
    x2: 154.5,
    y2: 367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorwhite);
export default __webpack_public_path__ + "static/media/Vectorwhite.134fa42b6883617550bc983d3d6ee8a8.svg";
export { ForwardRef as ReactComponent };